"use strict";

exports.__esModule = true;
var metadata = {
  stage: 1,
  dependencies: ["es6.classes"]
};
exports.metadata = metadata;


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/lib/transformation/transformers/es7/class-properties.js
// module id = 2106
// module chunks = 0